
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-kpi-card',
  templateUrl: './kpi-card.component.html',
  styleUrls: ['./kpi-card.component.scss']
})
export class KpiCardComponent implements OnInit {
  @Input() title: string = '';  
  @Input() value: number = 0; 
  @Input() icon: string = '';  
  @Input() color: string = '';
  @Input() image: string = '';
  @Input() titleColor: string = '';
@Input() valueColor: string = '';
@Input() bgColor: string = '';
@Input() titleSize: string = '';
@Input() valueSize: string = '';
@Input() imageSize: string = '';
@Input() titleWeight: string = '';
  constructor() { }

  ngOnInit(): void {
  }

}